<template>
    <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <b-tabs pills vertical nav-class="p-0" nav-wrapper-class="col-2" content-class="text-primary">
              <b-tab active class="border-0">
                <template v-slot:title>Modules</template>
                <table class="table table-hover mt-2" style="color: black;">
                <thead><tr><th>Role Name</th><th>Dashboard</th><th>Sales</th><th>Medicine</th><th>Inventory</th><th>Expenses</th><th>Reports</th><th>Settings</th></tr></thead>
                <tbody>
                <tr v-for="item in permissions" :key="item.id">
                  <td>{{ item.rolename }}</td>
                  <td>
                    <span v-if="item.view_dashboard==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='view_dashboard')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='view_dashboard')" /></span>
                  </td>
                  <td>
                    <span v-if="item.view_sales==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='view_sales')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='view_sales')" /></span>
                  </td>
                  <td>
                    <span v-if="item.view_medicine==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='view_medicine')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='view_medicine')" /></span>
                  </td>
                  <td>
                    <span v-if="item.view_inventory==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='view_inventory')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='view_inventory')" /></span>
                  </td>
                  <td>
                    <span v-if="item.view_expenses==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='view_expenses')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='view_expenses')" /></span>
                  </td>
                  <td>
                    <span v-if="item.view_reports==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='view_reports')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='view_reports')" /></span>
                  </td>
                  <td>
                    <span v-if="item.view_settings==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='view_settings')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='view_settings')" /></span>
                  </td>
                </tr>
                </tbody>
                </table>
              </b-tab>
              <!-- <b-tab>
                <template v-slot:title>Dashboard</template>
                <table class="table table-hover mt-2" style="color: black;">
                <thead><tr><th>Role Name</th><th>View Sales</th><th>View Purchases</th><th>View Expenses</th><th>View Demand</th><th>View Monthly Analysis</th></tr></thead>
                <tbody>
                <tr v-for="item in permissions" :key="item.id">
                  <td>{{ item.rolename }}</td>
                  <td>
                    <span v-if="item.new_patient==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='new_patient')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='new_patient')" /></span>
                  </td>
                  <td>
                    <span v-if="item.patient_triage==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='patient_triage')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='patient_triage')" /></span>
                  </td>
                  <td>
                    <span v-if="item.views_sales==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='patient_triage')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='patient_triage')" /></span>
                  </td>
                  <td>
                    <span v-if="item.patient_visits==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='patient_visits')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='patient_visits')" /></span>
                  </td>
                  <td>
                    <span v-if="item.patient_view==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='patient_view')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='patient_view')" /></span>
                  </td>
                  <td>
                    <span v-if="item.patient_appointments==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='patient_appointments')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='patient_appointments')" /></span>
                  </td>
                </tr>
                </tbody>
                </table>
              </b-tab> -->
              <b-tab>
                <template v-slot:title>Sales</template>
                <table class="table table-hover mt-2" style="color: black;">
                <thead><tr><th>Role Name</th><th>Add a Sale</th><th>Add to Cart</th><th>Confirm Sale</th><th>View Sales</th><th>View Details</th><th>Add Customers</th></tr></thead>
                <tbody>
                <tr v-for="item in permissions" :key="item.id">
                  <td>{{ item.rolename }}</td>
                  <td>
                    <span v-if="item.add_sales==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='add_sales')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='add_sales')" /></span>
                  </td>
                  <td>
                    <span v-if="item.sale_cart==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='sale_cart')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='sale_cart')" /></span>
                  </td>
                  <td>
                    <span v-if="item.confirm_sale==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='confirm_sale')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='confirm_sale')" /></span>
                  </td>
                  <td>
                    <span v-if="item.view_sales_info==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='view_sales_info')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='view_sales_info')" /></span>
                  </td>
                  <td>
                    <span v-if="item.view_sale_details==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='view_sale_details')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='view_sale_details')" /></span>
                  </td>
                  <td>
                    <span v-if="item.add_customer==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='add_customer')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='add_customer')" /></span>
                  </td>
                </tr>
                </tbody>
                </table>
              </b-tab>
              <b-tab>
                <template v-slot:title>Medicine</template>
                <table class="table table-hover mt-2" style="color: black;">
                <thead><tr><th>Role Name</th><th>View Products</th><th>Edit Products</th><th>Delete Products</th><th>View Units & Categories</th><th>Edit Units & Categories</th><th>Delete Units & Categories</th></tr></thead>
                <tbody>
                <tr v-for="item in permissions" :key="item.id">
                  <td>{{ item.rolename }}</td>
                  <td>
                    <span v-if="item.view_products==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='view_products')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='view_products')" /></span>
                  </td>
                  <td>
                    <span v-if="item.edit_products==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='edit_products')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='edit_products')" /></span>
                  </td>
                  <td>
                    <span v-if="item.delete_products==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='delete_products')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='delete_products')" /></span>
                  </td>
                  <td>
                    <span v-if="item.view_categories==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='view_categories')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='view_categories')" /></span>
                  </td>
                  <td>
                    <span v-if="item.edit_categories==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='edit_categories')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='edit_categories')" /></span>
                  </td>
                  <td>
                    <span v-if="item.delete_categories==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='delete_categories')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='delete_categories')" /></span>
                  </td>
                </tr>
                </tbody>
                </table>
              </b-tab>
              <b-tab>
                <template v-slot:title>Inventory</template>
                <table class="table table-hover mt-2" style="color: black;">
                <thead><tr><th>Role Name</th><th>Add Stock</th><th>Add to Cart</th><th>Confirm Purchase</th><th>View Stock Levels</th><th>Reconcile Stock</th><th>View Suppliers</th><th>Delete & Edit Supplier</th></tr></thead>
                <tbody>
                <tr v-for="item in permissions" :key="item.id">
                  <td>{{ item.rolename }}</td>
                  <td>
                    <span v-if="item.add_stock==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='add_stock')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='add_stock')" /></span>
                  </td>
                  <td>
                    <span v-if="item.stock_cart==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='stock_cart')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='stock_cart')" /></span>
                  </td>
                  <td>
                    <span v-if="item.confirm_purcahse==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='confirm_purcahse')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='confirm_purcahse')" /></span>
                  </td>
                  <td>
                    <span v-if="item.view_stock_levels==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='view_stock_levels')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='view_stock_levels')" /></span>
                  </td>
                  <td>
                    <span v-if="item.reconcile_stock==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='reconcile_stock')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='reconcile_stock')" /></span>
                  </td>
                  <td>
                    <span v-if="item.view_suppliers==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='view_suppliers')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='view_suppliers')" /></span>
                  </td>
                  <td>
                    <span v-if="item.edit_suppliers==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='edit_suppliers')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='edit_suppliers')" /></span>
                  </td>
                </tr>
                </tbody>
                </table>
              </b-tab>
              <b-tab>
                <template v-slot:title>Expenses</template>
                <table class="table table-hover mt-2" style="color: black;">
                <thead><tr><th>Role Name</th><th>Add Expense</th><th>Add to Cart</th><th>Confirm Payment</th><th>Change Items & Categories</th></tr></thead>
                <tbody>
                <tr v-for="item in permissions" :key="item.id">
                  <td>{{ item.rolename }}</td>
                  <td>
                    <span v-if="item.add_expense==1"><RockerSwitch :value="true" @change="changePermission(role=item.role, permission='add_expense')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='add_expense')" /></span>
                  </td>
                  <td>
                    <span v-if="item.expense_cart==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='expense_cart')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='expense_cart')" /></span>
                  </td>
                  <td>
                    <span v-if="item.confirm_payment==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='confirm_payment')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='confirm_payment')" /></span>
                  </td>
                  <td>
                    <span v-if="item.expense_categories==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='expense_categories')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='expense_categories')" /></span>
                  </td>
                </tr>
                </tbody>
                </table>
              </b-tab>
              <!-- system settings -->
              <b-tab>
                <template v-slot:title>System Settings</template>
                <table class="table table-hover mt-2" style="color: black;">
                <thead><tr><th>Role Name</th><th>Change Password</th><th>Edit Expenses</th></tr></thead>
                <tbody>
                <tr v-for="item in permissions" :key="item.id">
                  <td>{{ item.rolename }}</td>
                  <td>
                    <span v-if="item.change_password==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='change_password')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='change_password')" /></span>
                  </td>
                  <td>
                    <span v-if="item.edit_expense==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='edit_expense')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='edit_expense')" /></span>
                  </td>
                  
                </tr>
                </tbody>
                </table>
              </b-tab>
            </b-tabs>
            </div>
          </div>
        </div>
      </div>
    
    </Layout>
  </template>
  
  <script>
  import axios from "axios";
  import RockerSwitch from "vue-rocker-switch";
  import "vue-rocker-switch/dist/vue-rocker-switch.css";

  import Layout from "../../layouts/main";
  import PageHeader from "@/components/page-header";
  import appConfig from "@/app.config";
  import { permissionMethods, permissionComputed } from "@/state/helpers";
  
  export default {
    page: {
      title: "System Permissions",
      meta: [{ name: "description", content: appConfig.description,},],
    },
    components: {
      Layout,PageHeader,RockerSwitch
    },
    data() {
      return {
        userData: JSON.parse(localStorage.getItem("user")),
        title: "System Permissions",
        items: [ {text: "Dashboard",to: "/",}, {text: "System Permissions",active: true, }, ],
        isBusy: true,
        role:'',
        permission:'',
      };
    },
    computed: {
      ...permissionComputed,
      Fields() { return this.fields.filter(field => field.visible) },
      Items() { return this.permissions.map((d) => ({...d }))},
      IsBusy() { let a=false; if (this.permissions.length>0) { a=false;} else { a=true;} return a },
    },
    mounted() {
      this.fetchPermissions();
      this.isBusy=false;
    },
    methods: {
      ...permissionMethods,
      async changePermission(role,permission) {
        this.role=role; 
        this.permission=permission;
        let formData = new FormData();
        formData.append("role", this.role);
        formData.append("permission", this.permission);
        let url = "/updatepermission";
        await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
            this.fetchPermissions();
            this.role="";
            this.permission="";
        }
        });
      },
    },
  };
  </script>